module.exports = "/_next/static/images/Security-xs@2x-fd763abf6ac0bde150af04533202f77a.webp";